import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';

// Shared WhatsApp UI settings that span tabs — e.g. the read-receipt (blue tick)
// toggle is set on the Settings tab but must affect how ticks render in the
// Inbox. Kept in context so both tabs read/write the same value.
// TODO(api): hydrate these from GET /api/whatsapp/settings and persist on change.
const WaSettingsContext = createContext({
  readReceipts: true,
  setReadReceipts: () => {},
  activeTab: 0,
  setActiveTab: () => {},
  activeConvoId: null,
  setActiveConvoId: () => {},
  inboxActiveId: null,
  setInboxActiveId: () => {},
});

export const useWaSettings = () => useContext(WaSettingsContext);

export const WaSettingsProvider = ({ children }) => {
  const [readReceipts, setReadReceipts] = useState(true);
  const [activeTab, setActiveTab] = useState(() => {
    const saved = localStorage.getItem('wa_active_tab');
    return saved !== null ? parseInt(saved, 10) : 0;
  });
  const [activeConvoId, setActiveConvoId] = useState(null);
  const [inboxActiveId, setInboxActiveId] = useState(null);

  useEffect(() => {
    localStorage.setItem('wa_active_tab', activeTab);
  }, [activeTab]);

  const value = useMemo(() => ({
    readReceipts, setReadReceipts,
    activeTab, setActiveTab,
    activeConvoId, setActiveConvoId,
    inboxActiveId, setInboxActiveId
  }), [readReceipts, activeTab, activeConvoId, inboxActiveId]);

  return <WaSettingsContext.Provider value={value}>{children}</WaSettingsContext.Provider>;
};

export default WaSettingsContext;
